import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import {
  compose
  // withProps,
  // withState,
  // withHandlers
} from 'recompose';
import { withScriptjs, withGoogleMap, GoogleMap } from 'react-google-maps';

import { connect } from 'react-redux';
import axios from 'axios';
import { devLog, CancellationToken } from '../functions';
import { catchError } from '../actions';
import {
  addAreaToList,
  removeAreaFromList,
  postNumToPrintNum,
  setRootAreaId,
	resetAreasDialog
} from '../actions/areas';
import { selectOptions, selectOptionsUpdate } from '../actions/options';
import { setCalendarMode, getCalendar } from '../actions/calendar';

import {
  OptionTypes,
  DefaultRootAreas,
  CancelTokenIds
  //CalendarModeAreaIds
} from '../constants';
import MySnackbar from './MySnackbar';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

// import { cache } from 'sw-toolbox';
// import { selectOptions } from '../actions/options';

// ビルドエラーのためimportを止めて、定数をコピペする
// Failed to minify the code from this file: ./node_modules/react-google-maps/src/constants.js:1:7
// import { MAP } from "react-google-maps/src/constants"
export const MAP = `__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`;

let RootAreas=[];
const styles = theme => ({
  tabsRoot: {
    // backgroundColor: "#eee",
    backgroundColor: '#FFF000',
    borderBottom: '1px solid #d5d5d5',
    height: '38px',
    minHeight: '38px'
  },
  tabsIndicator: {
    // backgroundColor: "#40a9ff",
    backgroundColor: '#f00'
  },
  tabRoot: {
    opacity: 1,
    height: '38px',
    minHeight: '38px',
    minWidth: 50,
    color: '#000',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#999'
    },
		borderTopRightRadius: 10,
		fontSize: "0.9rem",
		[theme.breakpoints.down('md')]: {
			fontSize: "0.8rem",
		}
  },
  tabSelected: {
    backgroundColor: '#000',
    color: '#fff',
    fontWeight: 'bold'
  },
	labelContainer:{
		paddingLeft: 16,
		paddingRight: 16,
		[theme.breakpoints.down('md')]: {
			paddingLeft: 12,
			paddingRight: 12,
		},
		[theme.breakpoints.down('sm')]: {
			paddingLeft: 8,
			paddingRight: 8,
		}
	},
  swichMode: {
    position: 'absolute',
    top: -5,
    right: 0
  },
  swichModeLabel: {
    color: '#444',
    fontWeight: 'bold'
  },
  infoBar: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    position: 'absolute',
    bottom: 25,
    left: 10,
    '&:empty': {
      display: 'none'
    }
  },
  searchBar: {
    // ...theme.mixins.gutters(),
		backgroundColor: 'white',
    position: 'absolute',
    top: 48,
    left: 10,
		borderRadius: 4,
		boxShadow: '0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)',
  },
	searchBox:{
		//
	},
	searchBoxInput:{
		height: 36,
		width: 400,
		textIndent: 8
	},
	searchBoxUnderline:{
		borderBottom: 'none',
    '&:after': {
      borderBottom: 'solid 2px #40a9ff'
    }
	},
	searchButton:{
		marginTop: -4,
		color: "#FFF",
    backgroundColor: "#40a9ff",
    "&:hover": {
      backgroundColor: "#a9edff"
    },
		"&:disabled": {
			// color: "#FFF",
      backgroundColor: "#e4e4e4"
    }

	},
  // selectButton: {
  //   backgroundColor: '#f88',
  //   color: '#ffffff',
  //   fontWeight: 'bold',
  //   '&:hover': {
  //     backgroundColor: '#996666'
  //   }
  // }
});

//  ..
//  各レベルのカラーを設定
const colors = {
  base: {
    strokeColor: '#fff',
    fillColor: 'transparent',
    strokeWeight: 1,
    fillOpacity: 0.1
  },
  level1: {
    strokeColor: '#666',
    fillColor: '#999',
    strokeWeight: 3,
    fillOpacity: 0.1
  },
  level2: {
    strokeColor: '#006600',
    fillColor: '#22dd77',
    strokeWeight: 2,
    fillOpacity: 0.2
  },
  level3: {
    strokeColor: '#0d47a1',
    fillColor: '#0d47a1',
    strokeWeight: 1,
    fillOpacity: 0.2
  },
  active: {
    strokeColor: '#fff',
    fillColor: '#ff0000',
    fillOpacity: 0.3
  },
  circle: {
    strokeColor: '#FF0000',
    strokeOpacity: 0.8,
    strokeWeight: 3,
    fillColor: '#f00',
    fillOpacity: 0.2
  }
};
/*
 * CustomMap
 *
 *
 * ---------------------------------------------------------------------- */
const CustomMap = compose(
  withScriptjs,
  withGoogleMap
)(props => (
  <GoogleMap
    ref={props.onMapMounted}
    onZoomChanged={props.onZoomChanged}
    defaultZoom={9}
    defaultCenter={{ lat: 35.6964417, lng: 139.7680109 }}
    defaultOptions={{
      scrollwheel: true,
      zoomControl: true,
      gestureHandling: 'greedy',
      zoom: 9,
      maxZoom: 18,
      minZoom: 7,
      mapTypeControl: false,
      fullscreenControl: false,
      streetViewControl: false,
      zoomControlOptions: {
        position: window.google.maps.ControlPosition.TOP_RIGHT
      }
      // styles: [{
      //    strokeWeight: 1,
      //    strokeColor: 'blue',
      //    fillColor: 'blue',
      // }]
    }}
  ></GoogleMap>
));

/*
 * AreaMap
 *
 *
 * ---------------------------------------------------------------------- */
class AreaMap extends Component {
  state = {
    circleMode: false,
    rootAreaId: DefaultRootAreas[0].id,
    infoBarTxt: '',
    selectBar: {
      level: null,
      area_id: null,
      parent_id: null,
      name: null,
      num: null
    },
		searchValue: '',
    openResetDialog: false,
    errorMessage: null,
    searchErrorMessage: null
  };
  lastState = {
    circleMode: null,
    rootAreaId: null
  };
  cancellationTokens = [null, null];
  cancelingCounts = [0, 0];
  map = undefined;
  initalizedFLg = false;
	initalizedArea = false;
  eventListeners = {
    mouseover: null,
    click: null,
    center_changed: null,
    radius_changed: null
  };
  //
  targetFeatures = {
    level1: undefined,
    level2: undefined
  };
  displayedAreaIds = {
    level1: [],
    level2: [],
    level3: []
  };
  circle = {
    body: null,
    eventLock: false,
    timer: null
  };
	searching = false;

	componentWillMount() {
		if( 'initialRootAreas' in window && window.initialRootAreas.length ){
			RootAreas = window.initialRootAreas;
		}
		else{
			RootAreas = DefaultRootAreas;
		}
  }

  /*
   * handleMouseover
   * Data レイヤーマウスオーバー時の処理
   *
   * @params event
   * @return void
   * ---------------------------------------------------------------------- */
  handleMouseoverArea = event => {
    const name = event.feature.getProperty('name');
    const num = this.getNumFromFeature(event.feature);
    const formatter = new Intl.NumberFormat('ja-JP');
    const names = name.split(/\n/);
    let text = name + ' ' + formatter.format(num) + '部';
    if (names.length > 2) {
      text = names[1] + '+ 他 ' + formatter.format(num) + '部';
    }

    // 情報バーに表示する
    this.setState({ infoBarTxt: text });
  };

  /*
   * handleChangeRoot
   * タブによるルートエリアの切替
   *
   * @params event
   * @return void
   * ---------------------------------------------------------------------- */
  handleChangeRoot = (event, rootAreaId) => {
    // this.props.setRootAreaId(rootAreaId);
    this.setState({
      rootAreaId: rootAreaId,
      selectBar: { area_id: null },
      infoBarTxt: ''
    });
    this.props.setRootAreaId(rootAreaId); //2019/06/08
    this.props.selectOptions({ houseTypeId: 'n' });
		// 2019/11/15 スピードコースをデフォルトに
		// 2022/04/27 選択肢にスピードコースがあればそれ、なければゆっくりコース
		const selectId = this.props.optionsSpeedType.some( (option)=> option.value===2 ) ? 2 : 1;
    this.props.selectOptions({ speedTypeId: selectId });
  };

  /*
   * handleChangeSwitch
   * Switchコントロールの切り替え(選択モードの切替で使用)
   *
   * @params event
   * @return void
   * ---------------------------------------------------------------------- */
  handleChangeSwitch = name => event => {
    this.setState({ [name]: event.target.checked });
    this.setState({
      selectBar: { area_id: null },
      infoBarTxt: ''
    });
  };
  /*
   * onMapMounted
   * Mapがマウントされた時点で実行される
   *
   * @params void
   * @return void
   * ---------------------------------------------------------------------- */
  onMapMounted(ref) {
    // devLog('onMapMounted context',ref)
    if (ref === null) return;
    this.map = ref.context[MAP];
    if (!this.initalizedFLg) {
      if (this.props.areas.rootAreaId !== this.state.rootAreaId) {
        this.setState({ rootAreaId: this.props.areas.rootAreaId });
      }
      this.props.postNumToPrintNum();
      this.initalizedFLg = true;
		}
		else{
			//モードもしくはルートエリアの変更があれば初期化する
			if (this.lastState.rootAreaId !== this.state.rootAreaId) {
				this.lastState.rootAreaId = this.state.rootAreaId;
				this.lastState.circleMode = this.state.circleMode;
				this.initializeAreas(this.state.rootAreaId, true);
			} else if (this.lastState.circleMode !== this.state.circleMode) {
				this.lastState.rootAreaId = this.state.rootAreaId;
				this.lastState.circleMode = this.state.circleMode;
				this.initializeAreas(this.state.rootAreaId, false);
			}
		}
  }
  /*
   * initializeMap
   * Mapの初期設定(１度しか呼ばれない)
   *
   * @params void
   * @return void
   * ---------------------------------------------------------------------- */
  // initializeMap() {
  //     this.map.data.setStyle(colors.base);
  //      Event の登録
  //     this.map.data.addListener('mouseover', this.handleMouseoverArea);
  //     this.map.data.addListener('click', this.handleClickArea);
  // }

  /*
   * setListeners
   * Mapの初期設定(１度しか呼ばれない)
   *
   * @params void
   * @return void
   * ---------------------------------------------------------------------- */
  setListeners() {
    if (this.state.circleMode) {
      // イベントリスナーの削除
      if (this.eventListeners.mouseover !== null) {
        // this.map.data.removeListener( this.eventListeners.mouseover ); //NG
        // window.google.maps.event.clearListeners( this.map, 'mouseover'); //NG
        window.google.maps.event.removeListener(this.eventListeners.mouseover);
        this.eventListeners.mouseover = null;
      }
      if (this.eventListeners.click !== null) {
        window.google.maps.event.removeListener(this.eventListeners.click);
        this.eventListeners.click = null;
      }
      if (this.circle.body === null) {
        //  円の読み込み
        this.circle.body = new window.google.maps.Circle({
          ...colors.circle,
          map: this.map,
          center: this.map.center,
          editable: true,
          draggable: true,
          radius: 1000
        });
      } else {
        this.circle.body.setMap(this.map);
        this.circle.body.setCenter(this.map.center);
      }
      this.circle.eventLock = false;
      this.handleCircleChanged();
      // イベントリスナーの登録
      if (this.eventListeners.center_changed === null) {
        this.eventListeners.center_changed = this.circle.body.addListener(
          'center_changed',
          this.handleCircleChanged
        );
      }
      if (this.eventListeners.radius_changed === null) {
        this.eventListeners.radius_changed = this.circle.body.addListener(
          'radius_changed',
          this.handleCircleChanged
        );
      }
      // イベントロック用タイマー設定
      this.setIntervalEventLock();
    } else {
      // イベントリスナーの削除
      if (this.eventListeners.center_changed !== null) {
        window.google.maps.event.removeListener(
          this.eventListeners.center_changed
        );
        this.eventListeners.center_changed = null;
      }
      if (this.eventListeners.radius_changed !== null) {
        window.google.maps.event.removeListener(
          this.eventListeners.radius_changed
        );
        this.eventListeners.radius_changed = null;
      }
      // イベントリスナーの登録
      if (this.eventListeners.mouseover === null) {
        this.eventListeners.mouseover = this.map.data.addListener(
          'mouseover',
          this.handleMouseoverArea
        );
      }
      if (this.eventListeners.click === null) {
        this.eventListeners.click = this.map.data.addListener(
          'click',
          this.handleClickArea
        );
      }
      // イベントロック用タイマー設定を解除
      if (this.circle.body !== null) {
        this.circle.body.setMap(null);
        setTimeout(this.circle.timer);
      }
    }
  }
  /*
   * handleCircleChanged
   *
   *
   * @params void
   * @return void
   * ---------------------------------------------------------------------- */
  handleCircleChanged = async () => {
    if (this.circle.eventLock) {
      return;
    }
    //以前の読み込みをキャンセルし、キャンセル処理が完了するまで待つ
    await this.stayCanceling(CancelTokenIds.GET_JSON_TO_MAP);
    this.cancellationTokens[
      CancelTokenIds.GET_JSON_TO_MAP
    ] = new CancellationToken();

    const formatter = new Intl.NumberFormat('ja-JP');
    let errFlg = false;
    this.circle.eventLock = true;
    const center = this.circle.body.getCenter();
    let radius = this.circle.body.getRadius();
    const bounds = this.circle.body.getBounds();
    const boundsNE = bounds.getNorthEast();
    const boundsSW = bounds.getSouthWest();
    let radius_txt = '';

    //半径 ??? mを上限とする
    if (process.env.REACT_APP_AREA_RADIUS_MAX < radius) {
      radius = process.env.REACT_APP_AREA_RADIUS_MAX;
      this.circle.body.setRadius(Number(radius));
    }

    if (radius < 1000) {
      radius_txt = formatter.format(Math.round(radius)) + 'm';
    } else {
      radius_txt = formatter.format(Math.round(radius / 100) / 10) + 'km';
    }
    // マップの中心を移動
    this.map.setCenter(center);

    //情報バーに表示する
    this.setState({ infoBarTxt: '半径' + radius_txt });

    //今の表示を削除
    this.props.areas.areaIds.forEach(id => {
      const feature = this.map.data.getFeatureById(id);
      if (feature !== undefined) {
        this.map.data.overrideStyle(feature, { visible: false });
      }
    });
    let response;
    try {
      await this.cancelableFunction(async () => {
        response = await axios({
          method: 'POST',
          url: process.env.REACT_APP_API_URL,
          data: {
            mode: 'fetch_intersects',
            lat: center.lat(),
            lng: center.lng(),
            nelat: boundsNE.lat(),
            nelng: boundsNE.lng(),
            swlat: boundsSW.lat(),
            swlng: boundsSW.lng(),
            radius: radius
          }
        }).catch(e => {
          errFlg = catchError(e);
        });
      }, this.cancellationTokens[CancelTokenIds.GET_JSON_TO_MAP]);
    } catch (e) {
      devLog('cancell getJsonToMap', e);
      this.cancellationTokens[CancelTokenIds.GET_JSON_TO_MAP] = null; // トークンを除去
      return;
    }
    if (errFlg) return;

    let areaList = [];
    let areaIds = [];
    const areas = response.data;
    let nextCalendarMode = null;
    let calendarModeErr = false;

    areas.forEach(area => {
      // 配布カレンダーモードチェック --
      const areasCalendarMode = this.getCalendarMode(area);
      if (nextCalendarMode === null) {
        nextCalendarMode = areasCalendarMode;
      } else if (nextCalendarMode !== areasCalendarMode) {
        calendarModeErr = true;
        return;
      }
      // -- 配布カレンダーモードチェック
      const num = this.getNumFromArea(area);
      areaList.push({
        ...area,
        rootId: this.state.rootAreaId,
        num: num,
        maxNum: num
      });
      areaIds.push(area.id);
      this.getJsonToMap(area, true);
    });
    this.displayedAreaIds.level3 = areaIds;
    this.props.addAreaToList(areaList, areaIds);

    if (calendarModeErr) {
      const date = new Date();
      this.setState({
        errorMessage: {
          key: date.getTime(),
          msg: '配布ルールの異なるエリアは同時に選択できません。'
        }
      });
    }

    if (this.props.calendarMode !== nextCalendarMode) {
      this.props.setCalendarMode(nextCalendarMode);
      this.props.getCalendar(nextCalendarMode);
    }

    //
    this.cancellationTokens[CancelTokenIds.GET_JSON_TO_MAP] = null; // トークンを除去
  };
  /*
   * setIntervalEventLock
   *
   *
   * @params void
   * @return void
   * ---------------------------------------------------------------------- */
  setIntervalEventLock = () => {
    if (this.circle.timer === null) {
      this.circle.timer = () => {
        this.circle.eventLock = false;
      };
      setInterval(this.circle.timer, 300);
    }
  };

  // TODO: 再検証
  /*
   * stayCanceling
   * キャンセル処理が完了するまで待つ（0.1秒毎にチェック、最大30秒）
   *
   * @params tokenId
   * @return Promise
   * ---------------------------------------------------------------------- */
  stayCanceling = tokenId => {
    return new Promise((resolve, reject) => {
      if (this.cancellationTokens[tokenId]) {
        this.cancellationTokens[tokenId].cancel();
      } else {
        resolve();
        return;
      }
      //すでにキャンセル処理中の物がある場合
      const myCount = ++this.cancelingCounts[tokenId];
      //キャンセル処理が完了するまで待つ
      let ms = 0;
      const step = 100;
      const timer = setInterval(() => {
        devLog('stayCanceling', tokenId);
        ms += step;
        if (!this.cancellationTokens[tokenId] || 3000 < ms) {
          clearInterval(timer);
          if (myCount === this.cancelingCounts[tokenId]) {
            resolve();
          } else {
            reject();
          }
        }
      }, step);
    });
  };

  // TODO: 再検証
  /*
   * stayCommit
   * 処理が完了するまで待つ（0.1秒毎にチェック、最大30秒）
   *
   * @params void
   * @return Promise
   * ---------------------------------------------------------------------- */
  stayCommit = () => {
    return new Promise(resolve => {
      if (this.flgCommit) {
        resolve();
        return;
      }
      //処理が完了するまで待つ
      let cnt = 0;
      const timer = setInterval(() => {
        devLog('stayCommit');
        cnt++;
        if (this.flgCommit || 300 < cnt) {
          clearInterval(timer);
          resolve();
        }
      }, 100);
    });
  };

  // TODO: 再検証
  /*
   * cancelableFunction
   * 引数で渡した関数 をキャンセル可能に。
   *
   * @params fn,cancellationToken
   * @return Promise
   * ---------------------------------------------------------------------- */
  cancelableFunction(fn, cancellationToken = null) {
    return new Promise(async (resolve, reject) => {
      if (cancellationToken) {
        cancellationToken.register(reject);
      }
      await fn();
      resolve();
    });
  }

  /*
   * clearAreas
   * 表示中のエリアを全削除
   *
   * @params event
   * @return void
   * ---------------------------------------------------------------------- */
  clearAreas() {
    //フォーカスエリアをリセット
    this.targetFeatures.level1 = undefined;
    this.targetFeatures.level2 = undefined;

    //表示中のエリアを全削除
    for (let level in this.displayedAreaIds) {
      this.displayedAreaIds[level].forEach(id => {
        const feature = this.map.data.getFeatureById(id);
        if (feature !== undefined) {
          this.map.data.remove(feature);
        }
      });
      this.displayedAreaIds[level] = [];
    }
  }

  /*
   * initializeAreas
   * エリアを初期化
   *
   * @params event
   * @return void
   * ---------------------------------------------------------------------- */
  async initializeAreas(root_area_id, resetForcus) {
    //以前の読み込みをキャンセルし、キャンセル処理が完了するまで待つ
    try {
      await this.stayCanceling(CancelTokenIds.GET_JSON_TO_MAP);
      await this.stayCanceling(CancelTokenIds.INITALIZE_AREAS);
    } catch (e) {
      //すでに新たな処理が発生しているので、この処理実行させずに終わらせる
      return;
    }

    this.cancellationTokens[
      CancelTokenIds.INITALIZE_AREAS
    ] = new CancellationToken();

    const { areas } = this.props;
    const rootArea = RootAreas.find(a => a.id === root_area_id);

		devLog('first forcus',this.initalizedArea);
		//初回かつ初期フォーカス地点が設定されている場合のみ
		if(!this.initalizedArea
			&& window.initialPoint !== undefined
			&& Object.keys(window.initialPoint).length
			&& window.initialPoint.root){
			devLog('initialPoint',window.initialPoint);
			this.map.setCenter({
				lat:window.initialPoint.lat,
				lng:window.initialPoint.lng
			});
			this.map.setZoom(window.initialPoint.zoom);
			this.initalizedArea = true; //初回終了を示す
			resetForcus = false; //フォーカスはリセットしない
		}
    else if (resetForcus) {
      //最初にフォーカスをあわせる
      if (rootArea !== undefined && rootArea.bounds !== undefined) {
        this.map.fitBounds(this.convertGoogleBounds(rootArea.bounds));
      }
    }

    //表示中のエリアを全削除
    this.clearAreas();

    //ベースカラーの設定
    this.map.data.setStyle(colors.base);

    //イベントの初期化・登録
    this.setListeners();

    //エリア情報の読み込み
    try {
      await this.cancelableFunction(async () => {
        await this.getInitialAreas(root_area_id);
      }, this.cancellationTokens[CancelTokenIds.INITALIZE_AREAS]);
    } catch (e) {
      //キャンセル時の処理をここに。
      devLog('cancell initialAreas', e);
      this.cancellationTokens[CancelTokenIds.INITALIZE_AREAS] = null; // トークンを除去
      return;
    }
    const initialAreaList = window.initialAreas[root_area_id];

    //エリアをMapに反映
    try {
      // ※ 逐次処理から並列処理に変更
      await this.cancelableFunction(async () => {
        await Promise.all(initialAreaList.map(a => this.getJsonToMap(a)));
      }, this.cancellationTokens[CancelTokenIds.INITALIZE_AREAS]);
    } catch (e) {
      devLog('cancell getJsonToMap', e);
      await this.clearAreas(); //表示中のエリアを全削除
      this.cancellationTokens[CancelTokenIds.INITALIZE_AREAS] = null; // トークンを除去
      return;
    }

    if (resetForcus) {
      //rootAreaが未定義の場合
      if (rootArea === undefined || rootArea.bounds === undefined) {
        try {
          await this.cancelableFunction(async () => {
            const features = this.displayedAreaIds.level1.map(id =>
              this.map.data.getFeatureById(id)
            );
            this.map.fitBounds(this.createBoundsByFeatures(features));
          }, this.cancellationTokens[CancelTokenIds.INITALIZE_AREAS]);
        } catch (e) {
          devLog('cancell LatLngBounds', e);
          this.cancellationTokens[CancelTokenIds.INITALIZE_AREAS] = null; // トークンを除去
          return;
        }
      }
    }

    //範囲選択モードならここまで
    if (this.state.circleMode) {
      //処理完了
      this.cancellationTokens[CancelTokenIds.INITALIZE_AREAS] = null; // トークンを除去
      const circleBounds = this.circle.body.getBounds();
      this.map.fitBounds(circleBounds, 200); //余白を数値指定
      return;
    }

    this.flgCommit = false;
    try {
      await this.cancelableFunction(async () => {
        // 今のルートで選択状態のエリアリストを取得
        const activeAreas = areas.list.filter(a => a.rootId === root_area_id);
        // const activeAreasLv1 = activeAreas.filter(a => (Number(a.level) === 1))
        const activeAreasLv2 = activeAreas.filter(a => Number(a.level) === 2);
        const activeAreasLv3 = activeAreas.filter(a => Number(a.level) === 3);

        //activeなエリアの兄弟エリアと、その親の兄弟エリアが表示対象になる。
        let activeParentIds = [];
        activeAreasLv2.forEach(a => {
          activeParentIds.push(a.parent_id);
        });
        activeAreasLv3.forEach(a => {
          activeParentIds.push(a.grandparent_id);
          activeParentIds.push(a.parent_id);
        });
        //重複IDの除去
        activeParentIds = activeParentIds.filter(
          (x, i, self) => self.indexOf(x) === i
        );

        //兄弟エリアの取得と表示
        // this.cancellationTokens[CancelTokenIds.GET_JSON_TO_MAP]
        await Promise.all(activeParentIds.map(id => this.getAreaChildren(id)));

        activeParentIds.forEach(id => {
          const feature = this.map.data.getFeatureById(id);
          this.map.data.overrideStyle(feature, { visible: false });
        });

        //activeに
        activeAreas.forEach(a => {
          this.setAreaColor(a.id, true);
        });
        this.flgCommit = true;
      }, this.cancellationTokens[CancelTokenIds.INITALIZE_AREAS]);
    } catch (e) {
      devLog('cancell activeAreas', e);
      await this.stayCommit();
      devLog('stayCommit end');
      await this.clearAreas(); //表示中のエリアを全削除
      this.cancellationTokens[CancelTokenIds.INITALIZE_AREAS] = null; // トークンを除去
      return;
    }

    if (resetForcus) {
      //選択されたエリアに合わせてフォーカスする
      let forcusFeatures = [];
      areas.list.forEach(a => {
        if (a.rootId === root_area_id) {
          let feature;
          if (Number(a.level) === 1 || Number(a.level) === 2) {
            feature = this.map.data.getFeatureById(a.id);
          } else if (Number(a.level) === 3) {
            feature = this.map.data.getFeatureById(a.parent_id);
          }
          if (feature !== undefined) {
            forcusFeatures.push(feature);
          }
        }
      });
      const forcusBoudns = this.createBoundsByFeatures(forcusFeatures);
      if (forcusBoudns !== undefined) {
        this.map.fitBounds(forcusBoudns);
      }
    }

    //処理完了
    this.cancellationTokens[CancelTokenIds.INITALIZE_AREAS] = null; // トークンを除去
  }

  /*
   * getInitialAreas
   * ルートエリアを読み込む
   *
   * @params event
   * @return void
   * ---------------------------------------------------------------------- */
  async getInitialAreas(root_area_id) {
    let errFlg = false;
    if (root_area_id in window.initialAreas) {
      devLog('window.initialAreas');
    } else {
      const initialResponse = await axios({
        method: 'POST',
        url: process.env.REACT_APP_API_URL,
        data: {
          mode: 'get_initial_area',
          root_area_id: root_area_id
        }
      }).catch(e => {
        errFlg = catchError(e);
      });
      if (errFlg) return;
      window.initialAreas[root_area_id] = initialResponse.data;
      devLog('get_initial_area');
    }
  }

  /*
   * getJsonToMap
   * json を読み込みMapに反映
   *
   * @params area
   * @return bool
   * ---------------------------------------------------------------------- */
  async getJsonToMap(area, setActive = null) {
    let geojson = null;
    let active;
    if (setActive !== null) {
      active = setActive;
    } else {
      active = -1 < this.props.areas.areaIds.indexOf(Number(area.id));
    }
    try {
      await this.cancelableFunction(async () => {
        let json_url;
        let mbr = null;

        // 多重読み込みの防止
        const feature = this.map.data.getFeatureById(area.id);
        if (feature !== undefined) {
          feature.setProperty('active', active);
          this.map.data.overrideStyle(feature, { visible: true });
          if (
            -1 === this.displayedAreaIds['level' + area.level].indexOf(area.id)
          ) {
            this.displayedAreaIds['level' + area.level].push(area.id);
          }
          return false;
        }

        switch (Number(area.level)) {
          case 1:
            json_url =
              process.env.REACT_APP_JSON_URL + 'level1/' + area.id + '.json';
            geojson = await this.getJson(json_url);
            break;
          case 2:
            json_url =
              process.env.REACT_APP_JSON_URL +
              'level2/' +
              area.parent_id +
              '/' +
              area.id +
              '.json';
            geojson = await this.getJson(json_url);
            break;
          case 3:
            geojson = JSON.parse(area.json);
            break;
          default:
            return false;
        }
        if (geojson === null) {
          devLog('geojson is null id:', area.id);
          return false;
        }
        if (Number(area.level) === 1 || Number(area.level) === 2) {
          mbr = geojson.features[0].properties.mbr;
        }

        geojson.features[0].properties = {
          ...area,
          mbr: mbr, //フォーカス用情報
          active: active //選択状態
        };

        //表示リストに登録
        this.displayedAreaIds['level' + area.level].push(area.id);
      }, this.cancellationTokens[CancelTokenIds.GET_JSON_TO_MAP]);
    } catch (e) {
      devLog('cancell getJsonToMap', e, area);
      // this.cancellationTokens[CancelTokenIds.GET_JSON_TO_MAP] = null; // トークンを除去
      return;
    }
    //Mapに登録
    this.map.data.addGeoJson(geojson, { idPropertyName: 'id' });

    //エリアの色設定
    this.setAreaColor(area.id, active);

    return true;
  }

  /*
   * getJson
   * Json の読み込み
   *
   * @params json_url
   * @return json
   * ---------------------------------------------------------------------- */
  async getJson(json_url) {
    let errFlg = false;
    const response = await axios({
      method: 'GET',
      url: json_url
    }).catch(e => {
      errFlg = catchError(e);
    });
    if (errFlg) {
      devLog('Failed to read Area Json.', json_url);
      return null;
    }
    return response.data;
  }

  /*
   * processPoints
   * フォーカスをあわせる
   *
   * @params geometry, callback, thisArg
   * @return void
   * ---------------------------------------------------------------------- */
  processPoints(geometry, callback, thisArg) {
    if (geometry instanceof window.google.maps.LatLng) {
      callback.call(thisArg, geometry);
    } else if (geometry instanceof window.google.maps.Data.Point) {
      callback.call(thisArg, geometry.get());
    } else {
      geometry.getArray().forEach(g => {
        this.processPoints(g, callback, thisArg);
      });
    }
  }

  /*
   * activateArea
   * idから表示すべきエリアを割り出す
   *
   * @params id
   * @return void
   * ---------------------------------------------------------------------- */
  // async activateArea(area, unvisibleAreaIds) {
  //     //Mapに表示済みであれば色設定のみ行う
  //     const hitFlg = this.setAreaColor(area.id, true)
  //     if ( hitFlg ) {
  //         // const parentFeature = this.map.data.getFeatureById(area.parent_id)
  //         // if( parentFeature !== undefined ){
  //             return;
  //         // }
  //     }
  //     //Mapに存在しない場合は、データを取得する
  //     switch (Number(area.level)) {
  //         case 2:
  //             //親(lv1)を非表示リストに追加
  //             unvisibleAreaIds.push(area.parent_id)

  //             //兄弟エリアを表示状態に
  //             await this.getAreaChildren(area.parent_id)

  //             this.setAreaColor(area.id, true)
  //             break;
  //         case 3:
  //             //祖父(lv1)と親(lv2)を非表示リストに追加
  //             unvisibleAreaIds.push(area.grandparent_id)
  //             unvisibleAreaIds.push(area.parent_id)

  //             //親の兄弟エリアを表示状態に
  //             await this.getAreaChildren(area.grandparent_id)

  //             //兄弟エリアを表示状態に
  //             await this.getAreaChildren(area.parent_id)
  //             devLog(area)
  //             this.setAreaColor(area.id, true)
  //             break;
  //         default:
  //             return;
  //     }
  // }
  /*
   * getAreaChildren
   * 子エリアを取得 jsonも読み込み、Mapに反映
   *
   * @params id
   * @return void
   * ---------------------------------------------------------------------- */
  async getAreaChildren(parentId, children = { cnt: 0 }) {
    return new Promise(async (resolve, reject) => {
      // devLog('getAreaChildren parentId:',parentId)
      // 子エリア の一覧を ajax で取得後、json ファイルをロード
      // 速度的に 一覧取得時に PHP で json を開くのは NG とした
      let errFlg = false;
      const response = await axios({
        method: 'POST',
        url: process.env.REACT_APP_API_URL,
        data: {
          mode: 'fetch_children',
          area_id: parentId
        }
      }).catch(e => {
        errFlg = catchError(e);
      });
      if (errFlg) {
        reject();
      }

      children.cnt = response.data.length;

      if (response.data.length === 0) {
        devLog('not find children');
        resolve();
        return;
      }

      //  子エリアのJSONを取得し、Mapに反映
      // for (let key in response.data) {
      //     await this.getJsonToMap(response.data[key])
      //     // this.getJsonToMap(response.data[key])
      // }
      await Promise.all(response.data.map(a => this.getJsonToMap(a)));
      resolve();
    });
  }

  /*
   * getAreaFromFeature
   * feature から area情報を取得する
   *
   * @params feature
   * @return area
   * ---------------------------------------------------------------------- */
  getAreaFromFeature(feature) {
    if (feature === undefined) {
      return {
        id: null
      };
    }
    const area = {
      level: feature.getProperty('level'),
      grandparent_id: Number(feature.getProperty('grandparent_id')),
      parent_id: Number(feature.getProperty('parent_id')),
      parent_name: feature.getProperty('parent_name'),
      id: Number(feature.getProperty('id')),
      name: feature.getProperty('name'),
      short_name: feature.getProperty('short_name'),
      single: Number(feature.getProperty('single')),
      complex: Number(feature.getProperty('complex')),
      sum: Number(feature.getProperty('sum')),
      num: this.getNumFromFeature(feature),
      maxNum: this.getNumFromFeature(feature)
    };
    devLog('getAreaFromFeature:area.name', area.name);
    return area;
  }

  /*
   * getNumFromFeature
   * feature から 部数情報を取得する
   *
   * @params feature
   * @return num
   * ---------------------------------------------------------------------- */
  getNumFromFeature(feature) {
    switch (this.props.areas.houseTypeId) {
      default:
      case OptionTypes.HOUSE_NONE:
        return Number(feature.getProperty('sum'));
      case OptionTypes.HOUSE_SINGLE:
        return Number(feature.getProperty('single'));
      case OptionTypes.HOUSE_COMPLEX:
        return Number(feature.getProperty('complex'));
    }
  }

  /*
   * getNumFromArea
   * area情報 から 部数情報を取得する
   *
   * @params area
   * @return num
   * ---------------------------------------------------------------------- */
  getNumFromArea = area => {
    switch (this.props.areas.houseTypeId) {
      default:
      case OptionTypes.HOUSE_NONE:
        return Number(area.sum);
      case OptionTypes.HOUSE_SINGLE:
        return Number(area.single);
      case OptionTypes.HOUSE_COMPLEX:
        return Number(area.complex);
    }
  };

  /*
   * handleClickSelectButton
   * 「このエリア全体を選択」ボタンをクリックした場合
   *
   * @params event
   * @return void
   * ---------------------------------------------------------------------- */
  // handleClickSelectButton = async () => {
  //   //以前の読み込みをキャンセルし、キャンセル処理が完了するまで待つ
  //   await this.stayCanceling(CancelTokenIds.GET_JSON_TO_MAP);

  //   const feature = this.map.data.getFeatureById(this.state.selectBar.id);
  //   const selectId = Number(this.state.selectBar.id);

  //   this.addArea(feature);
  //   this.map.data.overrideStyle(feature, { visible: true });

  //   switch (Number(this.state.selectBar.level)) {
  //     case 1:
  //       this.displayedAreaIds.level2 = this.closeCurrentTargetArea(
  //         this.displayedAreaIds.level2,
  //         selectId
  //       );
  //       this.displayedAreaIds.level3 = this.closeCurrentTargetArea(
  //         this.displayedAreaIds.level3,
  //         selectId,
  //         'grandparent_id'
  //       );
  //       break;
  //     case 2:
  //       this.displayedAreaIds.level3 = this.closeCurrentTargetArea(
  //         this.displayedAreaIds.level3,
  //         selectId
  //       );
  //       break;
  //     default:
  //   }
  // };
  /*
   * closeCurrentTargetArea
   * エリアを閉じる（選択エリアを表示し、子エリアを削除）、表示リストを更新する
   *
   * @params displayedAreaIds, targetFeature, selectId
   * @return displayedAreaIds
   * ---------------------------------------------------------------------- */
  closeCurrentTargetArea(
    displayedAreaIds,
    selectId,
    checkProperty = 'parent_id'
  ) {
    let newList = [];
    // 表示中の子エリアを削除
    for (let i = 0; i < displayedAreaIds.length; i++) {
      let childeFeature = this.map.data.getFeatureById(displayedAreaIds[i]);
      if (childeFeature !== undefined) {
        if (selectId === Number(childeFeature.getProperty(checkProperty))) {
          this.map.data.remove(childeFeature);
        } else {
          newList.push(displayedAreaIds[i]);
        }
      }
    }
    return newList;
  }

  /*
   * handleClickArea
   * エリアをクリックした場合
   *
   * @params event
   * @return void
   * ---------------------------------------------------------------------- */
  handleClickArea = async event => {
    //以前の読み込みをキャンセルし、キャンセル処理が完了するまで待つ
    await this.stayCanceling(CancelTokenIds.GET_JSON_TO_MAP);
    this.cancellationTokens[
      CancelTokenIds.GET_JSON_TO_MAP
    ] = new CancellationToken();

    // const { areas } = this.props
    const level = Number(event.feature.getProperty('level'));
    const clickedAreaId = Number(event.feature.getProperty('id'));
    const clickedParentId = Number(event.feature.getProperty('parent_id'));
    const clickedGrandparentId = Number(
      event.feature.getProperty('grandparent_id')
    );
    const clickedActive = event.feature.getProperty('active');
    const parentFeature = this.map.data.getFeatureById(
      event.feature.getProperty('parent_id')
    );
    const grandparentFeature = this.map.data.getFeatureById(
      event.feature.getProperty('grandparent_id')
    );

    // 円形選択の絞り込み用
    // const base_area_id = clickedAreaId

    if (clickedActive) {
      // 選択中リストから削除する
      this.props.removeAreaFromList(clickedAreaId);
      this.setAreaColor(clickedAreaId, false);
    }

    // エリアのレベルによって処理を分ける
    switch (level) {
      //  level 1 を分解する
      case 1:
        // 円選択モードの解除
        // if(circle != null){
        //     circle.setMap(null);
        // }

        // selectBar にデータを設定
        // this.setState({
        //   ...this.state,
        //   selectBar: this.getAreaFromFeature(event.feature)
        // });

        // Mapにfitさせる
        this.map.fitBounds(this.createBounds(event.feature));

        //lv2,lv3エリアを閉じる（子エリアを削除）、表示リストを更新する
        this.closeLastTargetAreas(clickedParentId, clickedGrandparentId);

        // クリックしたエリアを非表示に
        this.map.data.overrideStyle(event.feature, { visible: false });

        // クリックしたエリアを登録
        this.targetFeatures.level1 = event.feature;

        // 読み込み > 反映 > 表示中のエリアリストにidを登録
        // this.getAreaChildren(clickedAreaId)
        await this.getAreaChildren(clickedAreaId);
        break;

      //  level 2 を分解する
      case 2:
        // selectBar にデータを設定
        if (clickedActive) {
          this.setState({
            ...this.state,
            selectBar: this.getAreaFromFeature(parentFeature)
          });
        } else {
          this.setState({
            ...this.state,
            selectBar: this.getAreaFromFeature(event.feature)
          });

          // Mapにfitさせる
          this.map.fitBounds(this.createBounds(event.feature));

          // lv2,lv3エリアを閉じる（子エリアを削除）、表示リストを更新する
          this.closeLastTargetAreas(clickedParentId, clickedGrandparentId);

          // クリックしたエリアを非表示に
          this.map.data.overrideStyle(event.feature, { visible: false });

          // クリックしたエリアを登録、親エリアも登録
          this.targetFeatures.level2 = event.feature;
          this.targetFeatures.level1 = parentFeature;

          // 読み込み > 反映 > 表示中のエリアリストにidを登録
          let children = { cnt: 0 };
          try {
            await this.getAreaChildren(clickedAreaId, children);
          } catch (e) {
            this.cancellationTokens[CancelTokenIds.GET_JSON_TO_MAP] = null; // トークンを除去
            return;
          }
          if (children.cnt === 0) {
            //子エリアが無いなら、これ自体を選択状態にする。
            this.map.data.overrideStyle(event.feature, { visible: true });
            this.addArea(event.feature);
          }
        }
        break;

      // level 3 を選択する
      case 3:
        // selectBar にデータを設定
        this.setState({
          ...this.state,
          selectBar: this.getAreaFromFeature(parentFeature)
        });

        //lv2,lv3エリアを閉じる（子エリアを削除）、表示リストを更新する
        this.closeLastTargetAreas(clickedParentId, clickedGrandparentId);

        if (!clickedActive) {
          // 選択中リストに追加する
          this.addArea(event.feature);
        }
        // クリックしたエリアの親エリア、祖父エリアを登録
        this.targetFeatures.level2 = parentFeature;
        this.targetFeatures.level1 = grandparentFeature;
        break;

      default:
    }
    this.cancellationTokens[CancelTokenIds.GET_JSON_TO_MAP] = null; // トークンを除去
  };
  /*
   * closeLastTargetAreas
   * 前回のエリアを閉じる
   *
   * @params displayedAreaIds, lastTargetFeature, currentTargetParentId, currentTargetGrandparentId
   * @return void
   * ---------------------------------------------------------------------- */
  closeLastTargetAreas(currentTargetParentId, currentTargetGrandparentId) {
    //lv2エリアを閉じる（子エリアを削除）、表示リストを更新する
    this.displayedAreaIds.level2 = this.closeLastTargetAreasS(
      this.displayedAreaIds.level2,
      this.targetFeatures.level1,
      currentTargetParentId,
      currentTargetGrandparentId
    );
    //lv3エリアを閉じる（孫エリアを削除）、表示リストを更新する
    this.displayedAreaIds.level3 = this.closeLastTargetAreasS(
      this.displayedAreaIds.level3,
      this.targetFeatures.level2,
      currentTargetParentId,
      currentTargetGrandparentId
    );
  }

  /*
   * closeLastTargetAreasS
   * 前回のエリアを閉じる（子エリアを削除）、表示リストを更新する
   *
   * @params displayedAreaIds, lastTargetFeature, currentTargetParentId
   * @return displayedAreaIds
   * ---------------------------------------------------------------------- */
  closeLastTargetAreasS(
    displayedAreaIds,
    lastTargetFeature,
    currentTargetParentId,
    currentTargetGrandparentId
  ) {
    const { areas } = this.props;

    //前回、フォーカスしてたエリアがあるとき
    if (lastTargetFeature !== undefined) {
      const lastTargetAreaId = Number(lastTargetFeature.getProperty('id'));

      //前回と兄弟関係のエリアを選択した場合は、表示の切替はしない
      if (
        lastTargetAreaId === currentTargetParentId ||
        lastTargetAreaId === currentTargetGrandparentId
      ) {
        return displayedAreaIds;
      }

      //そのエリアの子エリアを選択済みリストから取得
      const selectedAreasList = areas.list.filter(
        area =>
          area.parent_id === lastTargetAreaId ||
          area.grandparent_id === lastTargetAreaId
      );
      //内部に選択されてるエリアがなければ子エリアを削除
      if (selectedAreasList.length === 0) {
        //再表示する
        this.map.data.overrideStyle(lastTargetFeature, { visible: true });

        let newList = [];
        for (let i = 0; i < displayedAreaIds.length; i++) {
          const feature = this.map.data.getFeatureById(displayedAreaIds[i]);
          if (
            feature !== undefined &&
            lastTargetAreaId === Number(feature.getProperty('parent_id'))
          ) {
            this.map.data.remove(feature);
          } else {
            newList.push(displayedAreaIds[i]);
          }
        }
        return newList;
      } else {
        //選択されているエリアがある場合は、非表示にする、それ以外は何もしない
        this.map.data.overrideStyle(lastTargetFeature, { visible: false });
      }
    }
    return displayedAreaIds;
  }

  /*
   * createBounds
   * json data に記録された MBR から Bounds を生成
   *
   * @params event
   * @return void
   * ---------------------------------------------------------------------- */
  createBounds = feature => {
    let mbr = feature.getProperty('mbr');

    return new window.google.maps.LatLngBounds(
      new window.google.maps.LatLng(parseFloat(mbr.miny), parseFloat(mbr.minx)),
      new window.google.maps.LatLng(parseFloat(mbr.maxy), parseFloat(mbr.maxx))
    );
  };
  /*
   * createBoundsByFeatures
   * json data に記録された MBR から Bounds を生成、複数のfeatureから最小外接矩形を割り出す
   *
   * @params event
   * @return void
   * ---------------------------------------------------------------------- */
  createBoundsByFeatures = features => {
    let minYs = [],
      minXs = [],
      maxYs = [],
      maxXs = [];
    features.forEach(f => {
      if (f === undefined) {
        return;
      }
      const mbr = f.getProperty('mbr');
      if (mbr === undefined) {
        return;
      }
      minYs.push(mbr.miny);
      minXs.push(mbr.minx);
      maxYs.push(mbr.maxy);
      maxXs.push(mbr.maxx);
    });
    if (minYs.length === 0) {
      return undefined;
    }
    const Bounds = {
      min: {
        lat: Math.min(...minYs),
        lng: Math.min(...minXs)
      },
      max: {
        lat: Math.max(...maxYs),
        lng: Math.max(...maxXs)
      }
    };
    devLog('createBoundsByFeatures() Bounds:', Bounds);

    return new window.google.maps.LatLngBounds(
      new window.google.maps.LatLng(
        parseFloat(Bounds.min.lat),
        parseFloat(Bounds.min.lng)
      ),
      new window.google.maps.LatLng(
        parseFloat(Bounds.max.lat),
        parseFloat(Bounds.max.lng)
      )
    );
  };
  /*
   * convertGoogleBounds
   * 定数のBoundsをGoogleMapで扱うBoundsに変換する
   *
   * @params Bounds
   * @return Bounds
   * ---------------------------------------------------------------------- */
  convertGoogleBounds = Bounds => {
    return new window.google.maps.LatLngBounds(
      new window.google.maps.LatLng(
        parseFloat(Bounds.min.lat),
        parseFloat(Bounds.min.lng)
      ),
      new window.google.maps.LatLng(
        parseFloat(Bounds.max.lat),
        parseFloat(Bounds.max.lng)
      )
    );
  };

  /*
   * setAreaColor
   * エリアのlevelとavtiveステータスに応じて、色を設定する
   *
   * @params areaId,active
   * @return bool
   * ---------------------------------------------------------------------- */
  setAreaColor(areaId, active) {
    const feature = this.map.data.getFeatureById(areaId);
    if (feature === undefined) return false;
    const level = feature.getProperty('level');

    feature.setProperty('active', active);
    if (active) {
      this.map.data.overrideStyle(feature, colors.active);
    } else {
      this.map.data.overrideStyle(feature, colors['level' + level]);
    }
    return true;
  }

  // 配布カレンダーモードチェック
  getCalendarMode = area => {
    const { CalendarModeAreaIds } = this.props.calendarRules;
    let mode = 0;
    Object.keys(CalendarModeAreaIds).forEach((checkMode) => {
			const checkIds = CalendarModeAreaIds[checkMode];
      if (checkIds.length === 0) {
        return;
      }
      if (mode !== 0) {
        return;
      }
      const existing = checkIds.some(
        checkId =>
          area.id === checkId - 0 ||
          area.parent_id === checkId - 0  ||
          area.grandparent_id === checkId - 0
      );
      if (existing) {
        mode = checkMode;
      }
    });
    return mode;
  };

  /*
   * addArea
   * エリアをリストに追加する
   *
   * @params feature
   * @return void
   * ---------------------------------------------------------------------- */
  addArea(feature) {
    let { areas, calendarMode } = this.props;
    const area = this.getAreaFromFeature(feature);
    let areaList = [];
    let areaIds = [];
    let remove_key = null;
    let removeAreaList = [];

    if (-1 < areas.areaIds.indexOf(Number(area.id))) {
      return;
    }

    // 配布カレンダーモードチェック
    const areasCalendarMode = this.getCalendarMode(area);
    if (calendarMode !== areasCalendarMode) {
      if (areas.areaIds.length > 0 && calendarMode !== null) {
        // エリア選択エラー
        // console.error('配布ルールの異なるエリアは同時に選択できません。');
        const date = new Date();
        this.setState({
          openResetDialog: true,
          errorMessage: {
            key: date.getTime(),
            msg: '配布ルールの異なるエリアは同時に選択できません。'
          }
        });
        return;
      } else {
				this.props.selectOptionsUpdate( {calendarMode:areasCalendarMode} )
        this.props.setCalendarMode(areasCalendarMode);
        this.props.getCalendar(areasCalendarMode);
      }
    }

    //選択状態の色を設定
    this.setAreaColor(area.id, true);

    switch (Number(area.level)) {
      case 1:
        //子のリストを取得 > 削除リスト
        removeAreaList = areas.list.filter(
          a =>
            Number(a.parent_id) === Number(area.id) ||
            Number(a.grandparent_id) === Number(area.id)
        );
        //子孫以外のリストを取得 > 新リスト
        areaList = areas.list.filter(
          a =>
            !(
              Number(a.parent_id) === Number(area.id) ||
              Number(a.grandparent_id) === Number(area.id)
            )
        );
        areaIds = areaList.map(a => Number(a.id));
        break;
      case 2:
        //子のリストを取得 > 削除リスト
        removeAreaList = areas.list.filter(
          a => Number(a.parent_id) === Number(area.id)
        );
        //親を削除
        remove_key = areas.areaIds.indexOf(area.parent_id, 0);
        if (-1 < remove_key) {
          removeAreaList.push(areas.areaIds[remove_key]);
          areas.list.splice(remove_key, 1);
          areas.areaIds.splice(remove_key, 1);
        }
        //子以外のリストを取得 > 新リスト
        areaList = areas.list.filter(
          a => Number(a.parent_id) !== Number(area.id)
        );
        areaIds = areaList.map(a => Number(a.id));
        break;
      case 3:
        //親を削除
        remove_key = areas.areaIds.indexOf(area.parent_id, 0);
        if (-1 < remove_key) {
          removeAreaList.push(areas.areaIds[remove_key]);
          areas.list.splice(remove_key, 1);
          areas.areaIds.splice(remove_key, 1);
        }
        //親の親を削除
        remove_key = areas.areaIds.indexOf(area.grandparent_id, 0);
        if (-1 < remove_key) {
          removeAreaList.push(areas.areaIds[remove_key]);
          areas.list.splice(remove_key, 1);
          areas.areaIds.splice(remove_key, 1);
        }
        areaList = areas.list;
        areaIds = areas.areaIds;
        break;
      default:
        return;
    }
    //削除対象の色設定（active解除）
    removeAreaList.forEach(removeArea => {
      this.setAreaColor(removeArea.id, false);
    });
    areaList.push({ ...area, rootId: this.state.rootAreaId });
    areaIds.push(Number(area.id));

    this.props.addAreaToList(areaList, areaIds);
  }

  handleCloseResetDialog = () => {
    this.setState({ openResetDialog: false });
		this.props.resetAreasDialog(false);
  };

  handleResetAreas = () => {
    //選択をリセット
    this.props.addAreaToList([], []);
    this.initializeAreas(this.state.rootAreaId, true);
    this.setState({ openResetDialog: false });
		this.props.resetAreasDialog(false);
  };

	handleChangeSearchBox = (e) => {
		this.setState({
      searchValue: e.target.value
    });
	}

	handleKeyPressSearchBox = (e) =>{
		// エンターキー
		if(e.keyCode === 13){
			this.searchAddress();
		}
	}

	handleSearchButton = () =>{
			this.searchAddress();
	}

	searchAddress = () => {
		const searchValue = this.state.searchValue;
		const date = new Date();

		if( this.state.searching || ! searchValue.length ){
			return;
		}
		this.setState({ searching: true });

		const geocoder = new window.google.maps.Geocoder();
		geocoder.geocode({
			address: searchValue
		}, async (results, status) => {
			if (status === window.google.maps.GeocoderStatus.OK) {

				// const bounds = new window.google.maps.LatLngBounds();

				if (results[0].geometry) {
					// 緯度経度を取得
					const latlng = results[0].geometry.location;
					// 住所を取得
					const address = results[0].formatted_address;

					devLog({address,lat:latlng.lat(),lng:latlng.lng()});
					await this.searchArea(latlng);

					// 検索結果地が含まれるように範囲を拡大
					// bounds.extend(latlng);
					// this.map.fitBounds(bounds);
					// this.map.setZoom(14);
				}

			} else if (status === window.google.maps.GeocoderStatus.ZERO_RESULTS) {
				const msg = '住所を特定できませんでした';
				console.error(msg, searchValue);
				this.setState({
					searchErrorMessage: {
            key: date.getTime(),
            msg
          }
				});
			} else {
				const msg = 'システムエラー発生が発生しました';
				console.error(msg, searchValue);
				devLog(status);
				this.setState({
					searchErrorMessage: {
            key: date.getTime(),
            msg
          }
				});
			}
		});
		this.setState({ searching: false });
	}

	searchArea = async (latlng)=> {
		//以前の読み込みをキャンセルし、キャンセル処理が完了するまで待つ
		// await this.stayCanceling(CancelTokenIds.GET_JSON_TO_MAP);
		// this.cancellationTokens[
		// 	CancelTokenIds.GET_JSON_TO_MAP
		// ] = new CancellationToken();

		const searchValue = this.state.searchValue;
		const lat = latlng.lat();
		const lng = latlng.lng();
		const date = new Date();

		let errFlg = false;
		const response = await axios({
			method: 'POST',
			withCredentials: true,
			url: process.env.REACT_APP_API_URL + '',
			data: {
				mode: 'search_area',
				lat,
				lng
			}
		}).catch(e => {
			errFlg = catchError(e);
		});
		if (errFlg) return;

		devLog('search:response.data',response.data);

		if( ! response.data['lv0'] ){
			const msg = "そのエリアはMAP選択に対応しておりません。\n「ポスティング 全国」よりお問合せください。";
			console.error(msg, searchValue);
			this.setState({
				searchErrorMessage: {
					key: date.getTime(),
					msg: msg
				}
			});
			return false;
		}

		const { areas } = this.props;
		const rootAreaId = Number(response.data['lv0']);
		const lv1 = Number(response.data['lv1']);
		const lv2 = Number(response.data['lv2']);
		const zoom = 14;

		// 範囲選択モードであれば、フォーカス移動だけでいい。
		if( this.state.circleMode ){
			return await this.setInitialPoint(lat, lng, rootAreaId, zoom);
		}

		// NOTE: ルートの変更がない場合
		if( rootAreaId === this.state.rootAreaId ){
			//以前の読み込みをキャンセルし、キャンセル処理が完了するまで待つ
			await this.stayCanceling(CancelTokenIds.GET_JSON_TO_MAP);
			this.cancellationTokens[
				CancelTokenIds.GET_JSON_TO_MAP
			] = new CancellationToken();

			const bounds = new window.google.maps.LatLngBounds();
			// 検索結果地が含まれるように範囲を拡大
			bounds.extend(latlng);
			this.map.fitBounds(bounds);
			this.map.setZoom(zoom);
			// 今開いてるエリアを閉じる
			if(this.targetFeatures.level1){
				// 検索結果とは違うlv1を開いているなら閉じる
				const lv1TargetId = this.targetFeatures.level1.getProperty('id');
				if(lv1 !== lv1TargetId){
						// lv2,lv3エリアを閉じる（子エリアを削除）、表示リストを更新する
					this.closeLastTargetAreas(lv2, lv1);
				}
				// 検索結果とは違うlv2を開いているなら閉じる
				if(this.targetFeatures.level2){
					const lv2TargetId = this.targetFeatures.level2.getProperty('id');
					if(lv2 !== lv2TargetId){
						// lv2,lv3エリアを閉じる（子エリアを削除）、表示リストを更新する
						this.closeLastTargetAreas(lv2, lv1);
					}
				}
			}
		}
		//ルートが変更されるなら初期化
		else{
			await this.setInitialPoint(lat, lng, rootAreaId, zoom);
		}

		const featureLv1 = this.map.data.getFeatureById(lv1);
		// lv1 ターゲットとして登録
		this.targetFeatures.level1 = featureLv1;

		if( areas.list.some(a => a.grandparent_id === lv1) ){
			// 既に読み込んでいるはず
		}
		else{
			// lv1 非表示化
			this.map.data.overrideStyle(featureLv1, { visible: false });

			// lv2 読み込み > 反映 > 表示中のエリアリストにidを登録
			await this.getAreaChildren(lv1);
		}

		if( lv2 === 0 ){
			const msg = "そのエリアはMAP選択に対応しておりません。\n「ポスティング 全国」よりお問合せください。";
			console.error(msg, searchValue);
			this.setState({
				searchErrorMessage: {
					key: date.getTime(),
					msg: msg
				}
			});
			return false;
		}

		const featureLv2 = this.map.data.getFeatureById(lv2);

		// lv2 ターゲットとして登録
		this.targetFeatures.level2 = featureLv2;
		// lv2 非表示化
		this.map.data.overrideStyle(featureLv2, { visible: false });

		const activeAreasLv2 = areas.list.filter(a => a.parent_id === lv2);
		if(activeAreasLv2.length){
			// 既に読み込んでいるはず
		}
		else{
			// lv3 読み込み > 反映 > 表示中のエリアリストにidを登録
			let children = { cnt: 0 };
			try {
				await this.getAreaChildren(lv2, children);
			} catch (e) {
				this.cancellationTokens[CancelTokenIds.GET_JSON_TO_MAP] = null; // トークンを除去
				return;
			}
			if (children.cnt === 0) {
				// 子エリアが無いなら、これ自体を表示状態にする。
				this.map.data.overrideStyle(featureLv2, { visible: true });
			}
		}
		this.cancellationTokens[CancelTokenIds.GET_JSON_TO_MAP] = null; // トークンを除去
	}

	// 初期化し、フォーカスを指定位置に移動させる
	setInitialPoint = async ( lat, lng, rootAreaId, zoom )=> {
		this.initalizedArea = false;//初期化フラグをリセット
		window.initialPoint.root = rootAreaId;
		window.initialPoint.lng = lng;
		window.initialPoint.lat = lat;
		window.initialPoint.zoom = zoom;

		this.lastState.rootAreaId = rootAreaId; //自動的な初期化処理を防ぐ

		this.handleChangeRoot(null,rootAreaId);

		await this.initializeAreas(rootAreaId, true);
		return true;
	}

  /*
   * render
   * 描画
   * ---------------------------------------------------------------------- */
  render() {
    const { classes, areas } = this.props;
    const { openResetDialog, errorMessage, searchErrorMessage } = this.state;
    // const formatter = new Intl.NumberFormat('ja-JP');

    return (
      <div className="AreaMapComponent">
        {errorMessage ? (
          <MySnackbar
            key={errorMessage.key}
            variant="error"
            message={errorMessage.msg}
          />
        ) : null}

        <Dialog
          open={openResetDialog || areas.openResetDialog}
          onClose={this.handleCloseResetDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            選択エリアをリセットしてよろしいですか？
          </DialogTitle>
					{openResetDialog ?
						<DialogContent>
							<DialogContentText id="alert-dialog-description">
								配布ルールの異なるエリアは、同時に選択できません。
								<br />
								選択エリアをリセットして再選択する必要があります。
							</DialogContentText>
						</DialogContent>
					:''}
          <DialogActions>
            <Button onClick={this.handleCloseResetDialog} color="primary">
              いいえ
            </Button>
            <Button onClick={this.handleResetAreas} color="primary" autoFocus>
              リセットする
            </Button>
          </DialogActions>
        </Dialog>

				<Tabs
					classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
					value={this.state.rootAreaId}
					onChange={this.handleChangeRoot}
				>
					{Object.keys(RootAreas).map(key=>(
						<Tab
							key={key}
							classes={{ root: classes.tabRoot, selected: classes.tabSelected, labelContainer: classes.labelContainer }}
							value={RootAreas[key].id}
							label={RootAreas[key].name}
						/>
					))}
				</Tabs>
        <FormControlLabel
          classes={{ root: classes.swichMode, label: classes.swichModeLabel }}
          control={
            <Switch
              checked={this.state.circleMode}
              onChange={this.handleChangeSwitch('circleMode')}
              value="circleMode"
            />
          }
          label="範囲選択"
        />
        <CustomMap
          onMapMounted={this.onMapMounted.bind(this)}
          googleMapURL={
            'https://maps.googleapis.com/maps/api/js?key=' + window.gmap_apikey
          }
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: `calc(100vh - 173px)` }} />}
          mapElement={<div style={{ height: `100%` }} />}
        />
        <Paper className={classes.infoBar}>{this.state.infoBarTxt}</Paper>
				<div className={classes.searchBar}>
					<Input
						className={classes.searchBox}
						classes={{
							input:classes.searchBoxInput,
							underline:classes.searchBoxUnderline
						}}
						onChange={this.handleChangeSearchBox}
						onKeyDown={this.handleKeyPressSearchBox}
						value={this.state.searchValue}
						hiddenlabel="true"
						placeholder='住所を入力してください' />
					<Button className={classes.searchButton}
						onClick={this.handleSearchButton}
						disabled={!this.state.searchValue.length || this.state.searching}
						color="primary">
						検索
					</Button>
				</div>
				{searchErrorMessage ? (
          <MySnackbar
            key={searchErrorMessage.key}
            variant="search"
            message={searchErrorMessage.msg}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  areas: state.areas,
  calendarMode: state.calendar.mode,
  calendarRules: state.calendar.calendarRules,
	optionsSpeedType: state.options.speedType,
});

const mapDispatchToProps = dispatch => ({
  addAreaToList: (list, areaIds) => dispatch(addAreaToList(list, areaIds)),
  removeAreaFromList: areaId => dispatch(removeAreaFromList(areaId)),
  postNumToPrintNum: () => dispatch(postNumToPrintNum()),
  setRootAreaId: rootAreaId => dispatch(setRootAreaId(rootAreaId)),
  selectOptions: selected => dispatch(selectOptions(selected)),
	selectOptionsUpdate: selected => dispatch(selectOptionsUpdate(selected)),
  setCalendarMode: mode => dispatch(setCalendarMode(mode)),
  getCalendar: calendarMode => dispatch(getCalendar(calendarMode)),
	resetAreasDialog: (open) => dispatch(resetAreasDialog(open)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(AreaMap));



// WEBPACK FOOTER //
// ./src/components/AreaMap.js